import { render } from "./ListeInscriptionPage.vue?vue&type=template&id=6f00d8f2&ts=true"
import script from "./ListeInscriptionPage.vue?vue&type=script&lang=ts"
export * from "./ListeInscriptionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__